/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './style/dotsLoader.scss';

import React from 'react';
import classNames from 'classnames';
import BolSmile from "../../icon/bolSmile";

interface Props {
    className?: string;
    dotSize: number | string;
    noSmile?: boolean;
}

export function DotsLoader(props: Props) {
    const {className, dotSize, noSmile} = props;

    return (
        <div className={classNames('bol-dots-loader', className)}>
            <BolSmile className='dot-1' smile={false} size={dotSize}/>
            <BolSmile className='dot-2' size={dotSize} smile={!noSmile}/>
            <BolSmile className='dot-3' smile={false} size={dotSize}/>
        </div>
    )
}